type EstateObjectData = App.Data.EstateObject.EstateObjectData

/** Objects without a street fall back to their title so the address is never blank. */
export const estateObjectAddressLine = (estateObject: EstateObjectData): string =>
  [estateObject.street, estateObject.house_number, estateObject.address_addition].filter(Boolean).join(' ') ||
  (estateObject.title ?? '')
